import { ReactComponent as Default } from "../../resources/icon/equipment.svg";

const cpTu_cone_CLASS = "CPTU_CONE";
import { ReactComponent as cpTu_cone } from "../../resources/icon/equipments/gm-ctpu.svg";

const kompura_CLASS = "COMPRESSOR";
import { ReactComponent as Kompura } from "../../resources/icon/equipments/gm-kompura.svg";

const siipikaira_CLASS = "VANE_APPARATUS";
import { ReactComponent as Siipikaira } from "../../resources/icon/equipments/gm-siipikaira.svg";

const rod_CLASS = "ROD";
const positioning_device_CLASS = "POSITIONING_DEVICE";

const Geotanko_TYPE = "GEOTANKO";
import { ReactComponent as Geotanko } from "../../resources/icon/equipments/gm-geotanko.svg";

const Iskuputki_TYPE = "ISKUPUTKI";
import { ReactComponent as Iskuputki } from "../../resources/icon/equipments/gm-iskuputki.svg";

const Kairatanko_TYPE = "KAIRATANKO";
import { ReactComponent as Kairatanko } from "../../resources/icon/equipments/gm-kairatanko.svg";

export const getEquipmenImage = (equipment: any) => {
  let EquipmentClass =
    equipment && equipment.EquipmentClass ? equipment.EquipmentClass : null;
  const className =
    EquipmentClass && EquipmentClass.Name
      ? EquipmentClass.Name.toUpperCase()
      : "";

  const EquipmentType =
    equipment && equipment.EquipmentType ? equipment.EquipmentType : null;
  const typeName =
    EquipmentType && EquipmentType.Name ? EquipmentType.Name.toUpperCase() : "";

  if (className == rod_CLASS) {
    switch (typeName) {
      case Geotanko_TYPE:
        return Geotanko;
      case Iskuputki_TYPE:
        return Iskuputki;
      case Kairatanko_TYPE:
        return Kairatanko;
      default:
        break;
    }
  } else {
    switch (className) {
      case cpTu_cone_CLASS:
        return cpTu_cone;
      case kompura_CLASS:
        return Kompura;
      case siipikaira_CLASS:
        return Siipikaira;
      case positioning_device_CLASS:
      default:
        break;
    }
  }
  return Default;
};
